'use client';

import { useCallback, useState } from 'react';

export function useProductQuantity(max?: number) {
  const [quantity, setQuantity] = useState(1);

  const decrease = useCallback(() => {
    setQuantity((value) => Math.max(1, value - 1));
  }, []);

  const increase = useCallback(() => {
    setQuantity((value) => {
      if (typeof max === 'number' && value >= max) return value;
      return value + 1;
    });
  }, [max]);

  return { quantity, decrease, increase, setQuantity };
}
